__webpack_require__.p = "https://cp.trainer.f2b.dev/";